export const getActiveKey = () => {
    let key = window.location.pathname;
    if (key.startsWith("/")) {
        key = key.substring(1);
    }
    let pieces = key.split("/");
    key = "/" + pieces[0];
    // map certain urls to standard nav
    if (key === "/contact-thankyou") {
        key = "/contact";
    }
    if (key === "/register" || key === "/forgotpass") {
        key = "/login";
    }
    console.log("-- key: " + key)
    return key;
}

/* intersperse: Return an array with the separator interspersed between
 * each element of the input array.
 *
 * > _([1,2,3]).intersperse(0)
 * [1,0,2,0,3]
 */
export const intersperse = (arr, sep) => {
    if (arr.length === 0) {
        return [];
    }

    return arr.slice(1).reduce(function (xs, x, i) {
        return xs.concat([sep, x]);
    }, [arr[0]]);
}

export const isLoggedIn = () => {
    const user = JSON.parse(localStorage.getItem('user'));
    return !!(user && user.jwt_token);
}

export const isLoggedInWithRole = (role) => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.jwt_token) {
        if (user.is_admin) {
            return true;
        }
        if (role === 'host' && user.is_host) {
            return true;
        }
        if (role === 'performer' && user.is_performer) {
            return true;
        }
    }
    return false;
}

export const isLoggedInWithRoleAndUserIs = (role, entity_creator_id) => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.jwt_token) {
        if (user.is_admin) {
            return true;
        }
        if (role === 'host' && user.is_host && user.id === entity_creator_id) {
            return true;
        }
        if (role === 'performer' && user.is_performer && user.id === entity_creator_id) {
            return true;
        }
    }
    return false;
}

export const slotActIdMatch = (availableSlots, slotDef) => {
    let actId = null;
    let actName = null;
    if (availableSlots !== null && slotDef !== null) {
        availableSlots.forEach(function (s) {
            if (s.slot_def === slotDef) {
                if (s.scheduled_act !== null) {
                    actId = s.scheduled_act.id
                    actName = s.scheduled_act.name;
                }
            }
        });
    }
    return {"actId": actId, "actName": actName};
}

// return true if act can be schedules to a venue slot, fale owtherwise
export const actScheduledVenueSlotFilter = (act, slotNum, venueId) => {
    if (act.scheduled_venue_slots.length === 0) {
        // act has not been scheduled to any venue slot so far
        return true;
    } else {
        // act has been scheduled to a venue slot, but not necessarily to this specific one
        for (let i = 0; i < act.scheduled_venue_slots.length; i++) {
            // case: if it is the same venue slot, we should return true so the act shows up on the slot for the venue that scheduled it
            if (parseInt(act.scheduled_venue_slots[i].slot_def.substring(5)) === slotNum) {
                return act.scheduled_venue_slots[i].venue.id === venueId;
            }
        }
        // return true because we want to allow acts to be scheduled to more than one, non-overlapping slots
        // especially in the case of self hosted acts that want to cover several adjacent slots
        return true;
    }
}

export const addParam = (someUrl, paramName, paramValue) => {
    someUrl.searchParams.set(paramName, paramValue);
    return someUrl.toString();
}

export const actDropdownValue = (act) => {
    let s = act.name + " (preferred slots: ";
    for (let i = 0; i < act.preferred_slots.length; i++) {
        if (i > 0) {
            s += ", "
        }
        s += act.preferred_slots[i].substring(5);
    }
    s += ")";
    if (act.venue_pref) {
        s += " -- preferred venue: " + act.venue_pref;
    }
    return s;
}

export const capitalize = (val) => {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
}

export const toStrArray = (v) => [].concat(v).map(name => name)

export const GENRES = [
    {value: "americana", name: "Americana"},
    {value: "bluegrass", name: "Bluegrass"},
    {value: "blues", name: "Blues"},
    {value: "brass", name: "Brass"},
    {value: "classical", name: "Classical"},
    {value: "country", name: "Country"},
    {value: "dance", name: "Dance"},
    {value: "folk", name: "Folk"},
    {value: "funk", name: "Funk"},
    {value: "hiphop", name: "Hip Hop"},
    {value: "indie", name: "Indie"},
    {value: "jazz", name: "Jazz"},
    {value: "kids", name: "Kids"},
    {value: "pop", name: "Pop"},
    {value: "punk", name: "Punk"},
    // {value: "r_n_b", name: "R & B"},
    {value: "rock", name: "Rock"},
    // {value: "roots", name: "Roots"},
    {value: "singer_songwriter", name: "Singer Songwriter"},
    {value: "soul", name: "Soul"},
    {value: "spoken_word", name: "Spoken Word"},
    {value: "world", name: "World"},
    {value: "other", name: "Other"},
]

export const ACT_SIZES = [
    {value: "one_to_three", name: "1-3 persons"},
    {value: "four_plus", name: "4+ persons"},
]

export const ACT_SOUND_SYSTEM = [
    {value: "bring_own", name: "I will bring my own sound system/mixer"},
    {value: "avail_others", name: "I will bring my own sound system/mixer and I can make it available for others"},
    {value: "dont_need", name: "I don't need a sound system/mixer"},
    {value: "need_to_borrow", name: "I don't have a sound system/mixer and would like to borrow one, if possible"},
]

export const VENUE_SIZES = [
    {value: "any", name: "Any size"},
    {value: "one_to_three", name: "1-3 persons"},
    {value: "four_plus", name: "4+ persons"},
]

export const VENUE_ELECTRIC = [
    {value: "yes", name: "I can provide electricity for performers to use"},
    {value: "no", name: "I cannot provide electricity for performers"},
]

export const VENUE_SOUND = [
    {value: "yes", name: "I have a sound system that I can provide for the day"},
    {value: "no", name: "I cannot provide a sound system"},
]

export const SLOT_DESCRIPTIONS = {
    "Slot 1": "12:00pm - 1:00pm",
    "Slot 2": "1:30pm - 2:30pm",
    "Slot 3": "3:00pm - 4:00pm",
    "Slot 4": "4:30pm - 5:30pm"
};

export const sizeToText = (val) => {
    if (val === "one_to_three") {
        return "1-3 persons"
    }
    if (val === "four_plus") {
        return "4+ persons"
    }
    if (val === "any") {
        return "Any size"
    }
    return val;
}

export const sizeToTextBrief = (val) => {
    if (val === "one_to_three") {
        return "1-3 person act"
    }
    if (val === "four_plus") {
        return "4+ person act"
    }
    if (val === "any") {
        return "Any size act"
    }
    return val;
}

export const soundSystemToText = (val) => {
    if (val === "bring_own") {
        return "I will bring my own sound system/mixer"
    }
    if (val === "avail_others") {
        return "I will bring my own sound system/mixer and I can make it available for others"
    }
    if (val === "dont_need") {
        return "I don't need a sound system/mixer"
    }
    if (val === "need_to_borrow") {
        return "I don't have a sound system/mixer and would like to borrow one, if possible"
    }
    if (val === "yes") {
        return "I have a sound system that I can provide for the day"
    }
    if (val === "no") {
        return "I cannot provide a sound system"
    }
    return val;
}

export const soundSystemToTextBrief = (val) => {
    if (val === "yes") {
        return "Sound system provided"
    }
    if (val === "no") {
        return "Sound system not provided"
    }
    return val;
}

export const electricOutletToText = (val) => {
    if (val === "yes") {
        return "I can provide electricity for performers to use"
    }
    if (val === "no") {
        return "I cannot provide electricity for performers"
    }
    return val;
}

export const electricOutletToTextBrief = (val) => {
    if (val === "yes") {
        return "Electricity provided"
    }
    if (val === "no") {
        return "Electricity not provided"
    }
    return val;
}

export const CONTACT_CATEGORIES = [
    {value: "general", name: "General question"},
    {value: "technical_issue", name: "Technical issue"},
    {value: "matching", name: "Matching"},
    {value: "volunteering", name: "Volunteering"},
]

